import { useCallback } from 'react';

import { useFetchSignaal } from '@/queries/signalen/useFetchSignaal';
import useClientState from '@/state/useClientState';
import { SignaalEvent } from '@/types/Signalen';

/**
 * Custom hook voor het toevoegen van een via SSE-ontvangen signaal aan de clientState.
 * In de clientState worden deze platgeslagen naar een lijst van `Signaal` signalen.
 */
const useVerwerkSignaalBericht = () => {
  const voegNieuwSignaalBerichtToe = useClientState((state) => state.voegNieuwSignaalBerichtToe);
  const { fetchSignaalBericht } = useFetchSignaal();

  const verwerkSignaalBericht = useCallback(
    (signaalEvent: SignaalEvent) => {
      (async () => {
        try {
          const signaalBericht = await fetchSignaalBericht(signaalEvent.berichtId);
          voegNieuwSignaalBerichtToe(signaalBericht);
        } catch (error) {
          console.error(error);
        }
      })();
    },
    [fetchSignaalBericht, voegNieuwSignaalBerichtToe],
  );

  return { verwerkSignaalBericht };
};
export default useVerwerkSignaalBericht;
